import { create } from 'zustand'

const DEFAULT_FILTERS = {
  ghId: '', wsi: '', name: '', fullName: '',
  stationTypes: [], elevationMin: '', elevationMax: '',
  hierarchyPaths: [], basin: [], stationOwners: [],
  elAbbreviations: [], elMatchMode: 'any', elCurrentOnly: false,
  activeOnly: true,
  locality: null, localityRadius: '',
  osmLocality: null, osmLocalityRadius: '',
  plusGhId: '', minusGhId: '',
  groupPaths: [],
}

const DEFAULT_MAP_STATE = {
  center: [15.47, 49.82], // Default center (Czech Republic center)
  zoom: 7,
}

const DEFAULT_MAP_SETTINGS = {
  vizMode: 'type-color',
  labelMode: [], // pole kombinovatelných polí popisku (viz LABEL_MODES ve StationMap.jsx), [] = žádný
  showToolbar: true,
  showLegend: false,
  showHint: true,
}

const DEFAULT_UI_SETTINGS = {
  tableVisible: true,
  tableHeight: 260,
}

export const useStationStore = create((set) => ({
  selectedStation: null,
  setSelectedStation: (station) => set({ selectedStation: station }),
  clearSelectedStation: () => set({ selectedStation: null }),

  // Všechny stanice ze serveru
  allStations: [],
  setAllStations: (stations) => set({ allStations: stations }),

  // StationSelectLayout filtry
  stationSelectFilters: DEFAULT_FILTERS,
  setStationSelectFilters: (filters) => set({ stationSelectFilters: filters }),

  // Mapa stav (center, zoom)
  mapState: DEFAULT_MAP_STATE,
  setMapState: (mapState) => set({ mapState }),

  // Mapa nastavení (vizualizace, popisky, toolbar, legenda, hint)
  mapSettings: DEFAULT_MAP_SETTINGS,
  setMapSettings: (mapSettings) => set({ mapSettings }),

  // UI nastavení (viditelnost tabulky, atd.)
  uiSettings: DEFAULT_UI_SETTINGS,
  setUiSettings: (uiSettings) => set({ uiSettings }),
}))
